import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
/// Scroll
import LogoutPage from "./Logout";
/// Image
import { Dropdown } from "react-bootstrap";
import profile from "../../../images/profile/17.jpg";

const Header = ({ onNote, toggle, onProfile, onNotification, onClick }) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    const options = { month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTime = (date) => {
    return date.toTimeString().split(" ")[0]; // Sets format HH:MM:SS
  };
  var path = window.location.pathname.split("/");
  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div
              className="header-left d-flex align-items-center"
              style={{
                borderLeft: "2px solid #EBEBEB",
                paddingLeft: "1.25rem",
                height: "35px",
              }}
            >
              <div className="text-black fs-16">
                <span className="fw-bold text-black me-1">Today:</span>{" "}
                <span className="text-muted">{formatDate(currentTime)}</span>
                <span className="fw-bold text-black ms-4 me-1">Time:</span>{" "}
                <span className="text-muted">{formatTime(currentTime)}</span>
              </div>
            </div>
            <ul className="navbar-nav header-right align-items-center">
              <li className="nav-item d-flex align-items-center me-2 gap-2">
                <span className="text-muted fs-16">Kill switch</span>
                <div
                  className="form-check form-switch m-0"
                  style={{
                    transform: "scale(1.1)",
                    transformOrigin: "left center",
                  }}
                >
                  <input
                    className="form-check-input mb-0"
                    type="checkbox"
                    role="switch"
                    id="killSwitch"
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </li>
              <li className="nav-item d-flex align-items-center me-2">
                <Link to={"#"} className="nav-link p-0 text-muted">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#666"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                </Link>
              </li>
              <Dropdown as="li" className="nav-item header-profile ">
                <Dropdown.Toggle
                  as="a"
                  to="#"
                  variant=""
                  className="nav-link i-false c-pointer p-0 d-flex align-items-center ms-2"
                >
                  <div className="rounded-circle border border-2 border-white shadow-sm overflow-hidden bg-light">
                    <img
                      src={profile}
                      width="100%"
                      height="100%"
                      alt=""
                      style={{ objectFit: "contain" }}
                    />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  align="end"
                  className="mt-3 py-2 border-0 shadow-lg rounded-3"
                  style={{ minWidth: "200px" }}
                >
                  <div className="px-4 py-3">
                    <div className="fs-14 fw-bold text-black mb-0">
                      Franklin
                    </div>
                    <div className="fs-12 text-muted">Super Admin</div>
                  </div>
                  <div className="dropdown-divider border-light opacity-50 my-1"></div>
                  <LogoutPage />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
